export const logSecretly = (...args) => {
  const env = process.env.NODE_ENV;
  if (env === 'development' || env === 'test') {
    console.log(...args);
  }
};
